import { NgModule } from '@angular/core';
import { AuthFactoryService } from '../auth/authFactory.service';
import { CancellationGuard } from '../cancellation/guard/cancellation.guard';
import { Step2Guard } from '../cancellation/guard/step-2.guard';
import { CancellationService } from '../cancellation/services/cancellation.service';
import { DashboardService } from '../dashboard/services/dashboard.service';
import { ItineraryGuard } from '../search-result/guard/itinerary.guard';
import { ItineraryService } from '../search-result/services/itinerary.service';
import { OperationLogService } from '../search-result/services/operation-log.service';
import { SpecialRequestGuard } from '../special-requests/guard/special-requests.guard';
import { SpecialRequestService } from '../special-requests/services/special-request.service';
import { VoluntaryChangeGuard } from '../voluntary-change/guard/voluntary-change.guard';
import { VoluntaryChangeService } from '../voluntary-change/services/voluntary-change.service';
import { TpTravelService } from './api/tptravel.service';
import { APIService } from './api/general.service';
import { ArrayHelpersService } from './services/array-helper.service';
import { TicketHistoryService } from '../search-result/services/ticket-history.service';
import { TicketHistoryGuard } from '../search-result/guard/ticket-history.guard';
import { AuthGuard } from '../auth/guards/auth.guard';
import { ItineraryHistoryGuard } from '../search-result/guard/itinerary-history.guard';
import { ItineraryHistoryService } from '../search-result/services/itinerary-history.service';
import { ReissueGuard } from '../reissue/guard/reissue.guard';
import { ReissueService } from '../reissue/services/reissue.service';
import { InfantControlService } from '../search-result/services/infant-control.service';
import { ReRouteService } from '../re-route/services/re-route.service';

@NgModule({
  declarations: [],
  providers: [
    APIService,
    TpTravelService,
    ItineraryService,
    DashboardService,
    OperationLogService,
    CancellationService,
    ItineraryGuard,
    SpecialRequestGuard,
    CancellationGuard,
    Step2Guard,
    VoluntaryChangeGuard,
    SpecialRequestService,
    VoluntaryChangeService,
    AuthGuard,
    AuthFactoryService,
    ArrayHelpersService,
    TicketHistoryService,
    TicketHistoryGuard,
    ItineraryHistoryService,
    ItineraryHistoryGuard,
    ReissueGuard,
    ReissueService,
    InfantControlService,
    ReRouteService
  ]
})
export class CoreModule {}
